import { Link } from 'react-router-dom';
import type { NavItem } from './nav';
import { NavIcon } from './nav';

/**
 * Bottom tabs on a phone: four learner destinations, plus sponsor and admin when the role allows.
 * Graphite, with the lifted-blue current tab; the tab bar keeps its icons (D12). The current tab
 * is the destination the route belongs to, as in the rail.
 */
export function TabBar({ items, activePath }: { items: NavItem[]; activePath?: string | undefined }) {
  return (
    <nav
      aria-label="Primary"
      data-tab-bar=""
      className="fixed inset-x-0 bottom-0 z-40 bg-nav text-navInk rail:hidden"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <ul className="mx-auto flex max-w-2xl items-stretch justify-around px-2 pt-1">
        {items.map((item) => {
          const current = item.to === activePath;
          return (
            <li key={item.to} className="min-w-0 flex-1">
              <Link
                to={item.to}
                aria-current={current ? 'page' : undefined}
                className={`flex h-[60px] flex-col items-center justify-center gap-1.5 text-[12px] font-medium no-underline transition-colors duration-150 ease-ea ${
                  current ? 'text-navAcc' : 'text-navMute hover:text-navInk'
                }`}
              >
                <NavIcon name={item.icon} />
                <span className="truncate">{item.label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
